import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Enable React strict mode in development
const StrictModeWrapper = import.meta.env.DEV
  ? ({ children }: { children: React.ReactNode }) => (
      <React.StrictMode>{children}</React.StrictMode>
    )
  : ({ children }: { children: React.ReactNode }) => <>{children}</>;

// Initialize the React application
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <StrictModeWrapper>
    <App />
  </StrictModeWrapper>,
);

// Hot module replacement (HMR) for development
if (import.meta.hot) {
  import.meta.hot.accept();
}
